import { UI_PRIMITIVE__label_marquee } from '@/components/ui/UI_PRIMITIVE__label_marquee';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { get_token_style_color } from '@/utils/utils_tokens';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useMemo } from 'react';
import { HOOK__token_is_lora_tag } from './HOOK__token_is_lora_tag';

interface PROPS {
  field: FIELD__token;
}

export function G_UI_FIELD__token_list_item_header_word({ field }: PROPS) {
  /*
   * STORE
   */

  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);
  /*
   * STATE
   */

  let is_lora_tag = HOOK__token_is_lora_tag(field);
  let is_embedding = field.type == ENUM__token_type.EMBEDDING;

  const word = useMemo(() => get_word(), [field, ml_assets_map]);

  const class_name = is_lora_tag || is_embedding ? 'font-bold underline' : '';

  /*
   *
   */

  /*
   *
   */

  function get_word() {
    let out = field.word_english.get_value();

    if (field.type == ENUM__token_type.WORD) return out;

    let ml_assets_by_hash = DTO__ml_asset.map_by_hash(Array.from(ml_assets_map.values()));

    switch (field.type) {
      case ENUM__token_type.EMBEDDING:
        let ml_asset = ml_assets_by_hash.get_value_or_default(out, DTO__ml_asset.CREATE_STUB());

        if (!ml_asset.is_stub()) {
          out = `${ml_asset.name} ${ml_asset.version}`;
        }

        break;
      default:
        not_implemented_type(field.type);
    }

    return out;
  }

  /*
   *
   */

  function render_prefix() {
    if (is_lora_tag) return <span className="text-bar-foreground">lora: </span>;
    if (is_embedding) return <span className="text-bar-foreground">embedding: </span>;
    return null;
  }

  /*
   *
   */

  return (
    <div className="relative flex-1 min-w-0 max-w-32 overflow-hidden" style={{ color: get_token_style_color(field) }}>
      <UI_PRIMITIVE__label_marquee word={word} className={class_name} render_prefix={render_prefix} />
    </div>
  );
}
